/**
 *
 * @example https://developer.mozilla.org/en-US/docs/Web/API/Node/removeChild#simple_examples
 */
export function removeAllChildren(validDomNode: Element): Element {
	while (validDomNode.firstChild) {
		validDomNode.removeChild(validDomNode.firstChild);
	}

	return validDomNode;
}
